import $ from 'jquery';
import datepicker from 'air-datepicker';

class MaRSCommunityCareers {

  constructor() {
    // setTimeout(this.LoadActiveResults(), 750);
    this.forceNewTab();
    // LoadActiveResults
    this.resultsDiv = $(".allCareers__Results");
    this.showButton = $(".allCareers__link");
    this.filterSelect = $(".allCareers__filter-child li");
    this.searchField = $("#event-search");
    this.loadMoreButton = $(".allCareers__load a");
    this.postsPerPage = 12;
    this.screenWidth = $(window).width();
    // this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  events() {
    this.loadMoreButton.on("click", this.getMoreResults.bind(this));
    this.searchField.on("keyup", this.typingLogic.bind(this));
    this.filterSelect.on("click", this.filterLogic.bind(this));
  }

  typingLogic() {
    if (this.searchField.val() != this.previousValue || this.searchField.val() === '') {
      clearTimeout(this.typingTimer);
      $(".mtoggle li.active span").html($(".mtoggle li.active span").attr("data-hold"));
      if (this.searchField.val()) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
      } else {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(this.getResults.bind(this), 750);
        this.isSpinnerVisible = true;
      }
    }
    this.previousValue = this.searchField.val();
  }

  filterLogic(e) {
    if ($(this)) {
      let curTarget = e.currentTarget;
      let target, slug = e.target;
      target = slug.getAttribute('data-slug');
      let attrType = curTarget.parentElement.getAttribute('data-pane');

      if (target) {
        clearTimeout(this.typingTimer);
        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
      } else if (!target && !this.isOpened) {

        if (!this.isSpinnerVisible) {
          this.resultsDiv.html(`
          <div class="sk-double-bounce">
            <div class="sk-child sk-double-bounce1"></div>
            <div class="sk-child sk-double-bounce2"></div>
          </div>`);
          this.isSpinnerVisible = true;
        }
        this.searchField.val("");
        this.typingTimer = setTimeout(this.getFilterResults(attrType, target), 750);
        this.isSpinnerVisible = true;
      }
    }
  }


  getResults() {
    if ($(".allCareers__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?term=' + this.searchField.val() + '&page=1', (results) => {
        let currentPage = results.current_page;

        this.resultsDiv.html(`
            ${results.careerInfo.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${results.careerInfo.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" href="${item.open_external === true ? item.external_link : item.permalink}" ${item.open_external === true ? 'target="_blank"':''}>
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company_name}</span>
                      ${item.mars_venture ? '<span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>' : ''}
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.company_location}</span>
                      <span class="allCareers__type">${item.career_types[0]}</span>
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      ${item.open_external ? '<i class="allCareers__external"></i>' : ''}
                    </div>
                  </div>
                </a>
            `).join('')}
            ${results.careerInfo.length ? '</div>' : ''}
      `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`);
        // this.searchField.val() ? this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=2`) : '';
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getFilterResults(filter, sectorValue) {
    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?' + filter + '=' + sectorValue + '&page=1', (results) => {
      let currentPage = results.current_page;

      this.resultsDiv.html(`
            ${results.careerInfo.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${results.careerInfo.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" href="${item.open_external === true ? item.external_link : item.permalink}" ${item.open_external === true ? 'target="_blank"':''}>
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company_name}</span>
                      ${item.mars_venture ? '<span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>' : ''}
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.company_location}</span>
                      <span class="allCareers__type">${item.career_types[0]}</span>
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      ${item.open_external ? '<i class="allCareers__external"></i>' : ''}
                    </div>
                  </div>
                </a>
            `).join('')}
            ${results.careerInfo.length ? '</div>' : ''}
      `);
      this.isSpinnerVisible = false;
      sectorValue ? this.loadMoreButton.attr("data-url", `${filter}=${sectorValue}&page=2`) : this.loadMoreButton.attr("data-url", `term=${sectorValue}&page=2`);
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }


  LoadActiveResults() {

    if ($(".allCareers__Results").length) {
      $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?term=&page=1', (results) => {
        let currentPage = results.current_page;
        this.resultsDiv.html(`
            ${results.careerInfo.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${results.careerInfo.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" href="${item.open_external === true ? item.external_link : item.permalink}" ${item.open_external === true ? 'target="_blank"':''}>
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company_name}</span>
                      ${item.mars_venture ? '<span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>' : ''}
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.company_location}</span>
                      <span class="allCareers__type">${item.career_types[0]}</span>
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      ${item.open_external ? '<i class="allCareers__external"></i>' : ''}
                    </div>
                  </div>
                </a>
            `).join('')}
            ${results.careerInfo.length ? '</div>' : ''}
      `);
        this.isSpinnerVisible = false;
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
        `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
      }).fail(function (jqXHR, textStatus, error) {
      });
    }
  }


  getMoreResults(e) {
    e.preventDefault();
    this.loadInfo = this.loadMoreButton.attr("data-url");

    let currentAttrStr = this.loadInfo.split('=');
    let currentAttr = currentAttrStr[0];
    let currentAttrValue = currentAttrStr[1].split('&');

    if (!this.isSpinnerVisible) {
      this.resultsDiv.append(`
            <div class="sk-double-bounce">
              <div class="sk-child sk-double-bounce1"></div>
              <div class="sk-child sk-double-bounce2"></div>
            </div>`);
      this.isSpinnerVisible = true;
    }

    $.getJSON(MaRS_DATA.site_url + '/wp-json/mars/v1/careers?' + this.loadInfo, (results) => {
      let currentPage = results.current_page;
      this.resultsDiv.append(`
            ${results.careerInfo.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${results.careerInfo.map(item => `
                
                <a class="col-12 col-md-12 allCareers__career" href="${item.open_external === true ? item.external_link : item.permalink}" ${item.open_external === true ? 'target="_blank"':''}>
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company_name}</span>
                      ${item.mars_venture ? '<span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>' : ''}
                    </div>
                    
                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.company_location}</span>
                      <span class="allCareers__type">${item.career_types[0]}</span>
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      ${item.open_external ? '<i class="allCareers__external"></i>' : ''}
                    </div>
                  </div>
                </a>
            `).join('')}
            ${results.careerInfo.length ? '</div>' : ''}
      `);
      $('.sk-double-bounce').remove();
      this.isSpinnerVisible = false;
      if ( this.searchField.val().length > 1 ) {
        this.loadMoreButton.attr("data-url", `term=${this.searchField.val()}&page=${parseInt(currentPage) + 1}`);
      }
      else {
        this.loadMoreButton.attr("data-url", `${currentAttr}=${currentAttrValue[0]}&page=${parseInt(currentPage) + 1}`);
      }
      `${results.max_pages == currentPage ? this.loadMoreButton.hide() : this.loadMoreButton.show()}`;
    }).fail(function(jqXHR, textStatus, error) {
    });
  }

  forceNewTab(){

    setTimeout(() => {
      $(".BambooHR-ATS-Jobs-Item a").each(function(){
        $(this).attr("target", "_blank");
        $(this).attr("aria-label", "Link opens in a new tab");
      });
    }, "2000");
  }

}

export default MaRSCommunityCareers;